const doc = [({"ja":({"firstLineType":"最初のLINEタイプ", "continentsOrCruise":"大陸/クルーズ"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;